import React, { ReactNode } from "react";
import { connect } from "react-redux";

import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import Path from "@app/enum/Path";
import { getOrganization } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import hasTrialExpired from "@app/util/hasTrialExpired";

import styles from "./TrialExpiration.module.scss";

const TrialExpiration = ({ organization }: ReturnType<typeof mapStateToProps>) => {
  const intl = useIntl();
  if (!hasTrialExpired(organization)) {
    return null;
  }

  return (
    <Link className={styles.link} to={Path.BILLING}>
      <section className={styles.container}>
        <FontAwesomeIcon className={styles.icon} icon={faExclamationCircle} />
        <div className={styles.text}>
          {intl.formatMessage(
            {
              id: "trial.expired",
              defaultMessage:
                "<span>Your 7-day free trial has expired.</span><span>Please purchase a subscription to continue using Map My Customers.</span>",
              description: "Trial message to appear under nav bar when trial expires",
            },
            { span: (text: ReactNode) => <span>{text}</span> }
          )}
        </div>
      </section>
    </Link>
  );
};

const mapStateToProps = (state: RootState) => ({
  organization: getOrganization(state),
});

export default connect(mapStateToProps)(TrialExpiration);
